import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetCompanyQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:string|Number): Promise<any> {
    let args = {
        company_id: company_id
    }
    let res = undefined
    try {
        res = await this.dispatcher.dispatch('get_company.data', args)
    } catch(error) {
        console.error('Error get actual companydb', error)
    }
    this.frontend.actual_company = res
  }
}